export default __webpack_public_path__ + "static/media/ic-musica-searcher.24e555a0.svg";